import React from "react";
import Svg, { Path } from "react-native-svg";
import { TouchableOpacity } from "react-native";

export default function PlayStopIcon(props) {
  const isActive = props.isActive;

  return (
    <TouchableOpacity style={props.style} {...props}>
      {isActive ? (
        <Svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            d="M79.25 40.25C79.25 61.7629 61.7629 79.25 40.25 79.25C18.7371 79.25 1.25 61.7629 1.25 40.25C1.25 18.7371 18.7371 1.25 40.25 1.25C61.7629 1.25 79.25 18.7371 79.25 40.25Z"
            fill="#2FA4A5"
          />
          <Path
            d="M40.25 1.25C61.7629 1.25 79.25 18.7371 79.25 40.25C79.25 61.7629 61.7629 79.25 40.25 79.25"
            fill="#248F91"
          />
          <Path
            d="M12.6982 12.6984C27.9208 -2.52415 52.5789 -2.52415 67.8015 12.6984C83.0241 27.921 83.0241 52.5791 67.8015 67.8017"
            fill="#239C9D"
          />
          <Path
            d="M51.5724 38.7404C51.5724 36.0984 49.4337 33.9597 46.7918 33.9597H33.7079C31.066 33.9597 28.9272 36.0984 28.9272 38.7404V51.95C28.9272 54.592 31.066 56.7307 33.7079 56.7307H46.9176C49.5595 56.7307 51.6982 54.592 51.6982 51.95V38.7404H51.5724Z"
            fill="#248F91"
          />
          <Path
            d="M51.5724 33.708C51.5724 31.0661 49.4337 28.9274 46.7918 28.9274H33.7079C31.066 28.9274 28.9272 31.0661 28.9272 33.708V46.9177C28.9272 49.5596 31.066 51.6983 33.7079 51.6983H46.9176C49.5595 51.6983 51.6982 49.5596 51.6982 46.9177V33.708H51.5724Z"
            fill="white"
          />
        </Svg>
      ) : (
        <Svg
          width="78"
          height="78"
          viewBox="0 0 78 78"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            d="M76.7812 39C76.7812 59.8406 59.8406 76.7812 39 76.7812C18.1594 76.7812 1.21875 59.8406 1.21875 39C1.21875 18.1594 18.1594 1.21875 39 1.21875C59.8406 1.21875 76.7812 18.1594 76.7812 39Z"
            fill="#2FA4A5"
          />
          <Path
            d="M39 1.21875C59.8406 1.21875 76.7812 18.1594 76.7812 39C76.7812 59.8406 59.8406 76.7812 39 76.7812"
            fill="#248F91"
          />
          <Path
            d="M12.3096 12.3099C27.0564 -2.43696 50.9439 -2.43696 65.6908 12.3099C80.4377 27.0568 80.4377 50.9443 65.6908 65.6912"
            fill="#239C9D"
          />
          <Path
            d="M33.6375 56.1846C33.3938 56.1846 33.0281 56.0628 32.7844 55.9409C32.175 55.6971 31.6875 54.9659 31.6875 54.3565V31.5659C31.6875 30.9565 32.175 30.2253 32.7844 29.9815C33.3937 29.7378 34.125 29.7378 34.7344 30.1034L50.2125 41.5596C50.7 41.9253 50.9437 42.4128 50.9437 43.0221C50.9437 43.6315 50.7 44.119 50.2125 44.4846L34.7344 55.9409C34.3688 56.0628 34.0031 56.1846 33.6375 56.1846Z"
            fill="#248F91"
          />
          <Path
            d="M33.6375 52.1619C33.3938 52.1619 33.0281 52.0401 32.7844 51.9182C32.175 51.6744 31.6875 50.9432 31.6875 50.3338V27.5432C31.6875 26.9338 32.175 26.2026 32.7844 25.9588C33.3937 25.7151 34.125 25.7151 34.7344 26.0807L50.2125 37.5369C50.7 37.9026 50.9437 38.3901 50.9437 38.9994C50.9437 39.6088 50.7 40.0963 50.2125 40.4619L34.7344 51.9182C34.3688 52.0401 34.0031 52.1619 33.6375 52.1619Z"
            fill="white"
          />
        </Svg>
      )}
    </TouchableOpacity>
  );
}
